import styled from "styled-components";
import useScroll from "../custom_hooks/useScroll.tsx";
import UpButton from "../assets/img/common/up_button.png";

const Button = styled.button`
  width: 70px;
  height: 70px;
  position: fixed;
  right: 100px;
  bottom: 20px;
  opacity: 0;
  background: url(${UpButton});
  background-size: cover;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  border: none;
  transform: translateY(0px);
  transition: all 0.4s linear;
  visibility: hidden;
  z-index: 1;

  &.float {
    transform: translateY(-80px);
    opacity: 1;
    visibility: unset;
    transition: all 0.4s linear;
  }

  @media screen and (max-width: 750px) {
    right: 4px;
    width: 50px;
    height: 50px;
  }
`;

export default function FloatingTopButton() {
  const { y } = useScroll();
  const isFloating: boolean = y > 50;

  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  return (
    <Button
      id="btn-floating-top"
      className={isFloating ? "float" : ""}
      onClick={gotoTop}
    />
  );
}
